export interface ITabNavigation {
  className?: string;
  icon?: JSX.Element;
  trackingKey: string;
  setCurrentPage?: any;
  singlePage?: boolean;
  trackingEvent?: string;
  productSelected?: any[];
  isQuoteExpired?: boolean;
  portalNavigation?: boolean;
  pages: Array<React.ReactNode>;
  firstDetailPageRender?: boolean;
  tabLabels: Array<ITableLabel | any>;
  setTabFilter?: (filter: any) => any;
  distributionCenterSelected?: string;
  modalIsOpen?: {
    isOpen: boolean;
    isCancelButtonClicked: boolean;
    firstLoad: boolean;
  };
  allBudgetsSavedInQuote?: (distributionCenterTab?: string, isDiscarded?: boolean) => Promise<void>;
}

interface ITableLabel {
  label: string;
}

export enum CategoryType {
  MEDICINE = "MEDICINE",
  MATERIAL = "MATERIAL",
  NUTRITION = "NUTRITION",
  DEFAULT = "DEFAULT",
  OUT_PORTFOLIO = "OUT_PORTFOLIO"
}

export enum CategoryTypeNumber {
  "DEFAULT" = 6,
  "MEDICINE" = 1,
  "MATERIAL" = 4,
  "NUTRITION" = 7,
  "OUT_PORTFOLIO" = 8
}
